import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AdminState {
  editingMtmSettingsId: string | null;
  showMtmSettingsModal: boolean;
  editingMomentmSettingsId: string | null;
  showMomentmSettingsModal: boolean;
}

export const initialState: AdminState = {
  editingMtmSettingsId: null,
  showMtmSettingsModal: false,
  editingMomentmSettingsId: null,
  showMomentmSettingsModal: false,
};

export const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    setEditingMtmSettingsId: (state, action: PayloadAction<string | null>) => {
      state.editingMtmSettingsId = action.payload;
    },
    setShowMtmSettingsModal: (state, action: PayloadAction<boolean>) => {
      state.showMtmSettingsModal = action.payload;
    },
    setEditingMomentmSettingsId: (
      state,
      action: PayloadAction<string | null>
    ) => {
      state.editingMomentmSettingsId = action.payload;
    },
    setShowMomentmSettingsModal: (state, action: PayloadAction<boolean>) => {
      state.showMomentmSettingsModal = action.payload;
    },
  },
});

export const adminActions = adminSlice.actions;
